package pl.mothdigital.neuronowi.common.utils

import kotlinx.browser.*
import org.w3c.dom.*

fun Document.setDescription(description: String) {
    (head!!.querySelector("meta[name='description']") ?: document.createElement("meta").apply {
        setAttribute("name", "description")
        head!!.appendChild(this)
    }).setAttribute("content", description)
}

fun Document.setRobots(directives: String) {
    (head!!.querySelector("meta[name='robots']") ?: createElement("meta").apply {
        setAttribute("name", "robots")
        head!!.appendChild(this)
    }).setAttribute("content", directives)
}
